/* tslint:disable */
/* eslint-disable */
/**
 * CMS API
 * The CMS API!
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import globalAxios, { AxiosPromise, AxiosInstance } from 'axios';
import { Configuration } from '../configuration';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';
// @ts-ignore
import { ApiResponseOfSmartQueryParametersResponse } from '../model';
/**
 * SmartQueriesApi - axios parameter creator
 * @export
 */
export const SmartQueriesApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Returns all the available fields, sortings and operators to build smart queries
         * @param {Array<string>} [contentTypes] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getParameters: async (contentTypes?: Array<string>, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/smartQueries/parameters`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (contentTypes) {
                localVarQueryParameter['contentTypes'] = contentTypes;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * SmartQueriesApi - functional programming interface
 * @export
 */
export const SmartQueriesApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = SmartQueriesApiAxiosParamCreator(configuration)
    return {
        /**
         * Returns all the available fields, sortings and operators to build smart queries
         * @param {Array<string>} [contentTypes] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getParameters(contentTypes?: Array<string>, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiResponseOfSmartQueryParametersResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getParameters(contentTypes, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * SmartQueriesApi - factory interface
 * @export
 */
export const SmartQueriesApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = SmartQueriesApiFp(configuration)
    return {
        /**
         * Returns all the available fields, sortings and operators to build smart queries
         * @param {Array<string>} [contentTypes] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getParameters(contentTypes?: Array<string>, options?: any): AxiosPromise<ApiResponseOfSmartQueryParametersResponse> {
            return localVarFp.getParameters(contentTypes, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * SmartQueriesApi - interface
 * @export
 * @interface SmartQueriesApi
 */
export interface SmartQueriesApiInterface {
    /**
     * Returns all the available fields, sortings and operators to build smart queries
     * @param {Array<string>} [contentTypes] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SmartQueriesApiInterface
     */
    getParameters(contentTypes?: Array<string>, options?: any): AxiosPromise<ApiResponseOfSmartQueryParametersResponse>;

}

/**
 * SmartQueriesApi - object-oriented interface
 * @export
 * @class SmartQueriesApi
 * @extends {BaseAPI}
 */
export class SmartQueriesApi extends BaseAPI implements SmartQueriesApiInterface {
    /**
     * Returns all the available fields, sortings and operators to build smart queries
     * @param {Array<string>} [contentTypes] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SmartQueriesApi
     */
    public getParameters(contentTypes?: Array<string>, options?: any) {
        return SmartQueriesApiFp(this.configuration).getParameters(contentTypes, options).then((request) => request(this.axios, this.basePath));
    }
}
